import React, { forwardRef, useImperativeHandle, useEffect, useState, useRef } from 'react';
import { Form, Modal } from "reactstrap";
import Swal from 'sweetalert2';
import { Controller, useForm } from "react-hook-form";

import API from '../../API';
import { DateFormat, DateFormatJSON, NumberFormat, CleanMobile, TimeFormat, DateThaiFormat, RootURL } from '../../Utils/Function';
import { SearchSubDistrict, SearchCustomer } from '../../Utils/Search';
import { QuotationType, QuotationTypeName } from '../../Utils/Status';
import { ProductView } from '..';
import parse from 'html-react-parser'
import moment from 'moment';
import AsyncSelect from 'react-select/async';

import { ThaiDatePicker } from "thaidatepicker-react";
import "react-datepicker/dist/react-datepicker.css";
import NewWindow from 'react-new-window'
import PromotionItem from '../Promotion/PromotionItem';

const QuotationItem = forwardRef((props, ref) => {
    const { register, handleSubmit, watch, reset, getValues, setValue, control, formState: { errors } } = useForm();
    const [_Customer, setCustomer] = useState(null);
    const [_EventList, setEventList] = useState([]);
    const [_ItemSaveLength,setItemSaveLength] = useState(0);
    const [ModalState, setModalState] = useState(false);
    const [_ItemMode, setItemMode] = useState(1);
    const [_CustomerEventID, setCustomerEventID] = useState(null);
    const [_ItemRefID, setItemRefID] = useState(0);

    const [_PackageList, setPackageList] = useState([]);
    const [_ProductList, setProductList] = useState([]);

    const [PackageGroupList, setPackageGroupList] = useState([]);
    const [_ProductTypeList, setProductTypeList] = useState([]);
    useEffect(() => {
        return () => { }
    }, []);

    useImperativeHandle(ref, () => ({
        Show(Customer, EventList, ItemSaveLength) {
            console.log(ItemSaveLength);
            _ClearValue();
            setCustomer(Customer);
            setEventList(EventList);
            if(isNaN(ItemSaveLength)) 
                setItemSaveLength(0);
            else
                setItemSaveLength(ItemSaveLength);
            
            setItemMode(1);
            setPackageGroupList([]);
            setPackageList([]);
            setProductTypeList([]);
            setProductList([]);
            setCustomerEventID(null);
            setItemRefID(0);
            _GetPackageGroupList();
            _GetProductTypeList();
            setModalState(true);

        }
    }));

    const _ClearValue = () => {
        reset();


    }

    const _CloseModel = () => {
        setModalState(false);
    }

    const _GetPackageGroupList = () => {
        setPackageGroupList([]);
        API({ method: "get", url: "/Search/Package/Group" }).then(res => {
            if (res.status !== 200) return;
            if (!res.data.status) return;
            setPackageGroupList(res.data.data);
        }).catch(res => { return; });
    }

    const _GetPackageList = (GroupID) => {
        setPackageList([]);
        API({ method: "get", url: "/Search/Package?PackageGroupID=" + GroupID + "&Event=" + _CustomerEventID }).then(res => {
            if (res.status !== 200) return;
            if (!res.data.status) return;
            setItemRefID(GroupID);
            setPackageList(res.data.data);
        }).catch(res => { return; });
    }

    const _GetProductTypeList = () => {
        setProductTypeList([]);
        API({ method: "get", url: "/Search/Product/Type" }).then(res => {
            if (res.status !== 200) return;
            if (!res.data.status) return;
            setProductTypeList(res.data.data);
        }).catch(res => { return; });
    }

    const _GetProductList = (TypeID) => {
        setProductList([]);
        API({ method: "get", url: "/Search/Product?ProductTypeID=" + TypeID + "&Event=" + _CustomerEventID }).then(res => {
            if (res.status !== 200) return;
            if (!res.data.status) return;
            setItemRefID(TypeID);
            setProductList(res.data.data);
        }).catch(res => { return; });
    }
    const _ItemChangeEvent = (CustomerEventID) => {
        setCustomerEventID(CustomerEventID);
        if (CustomerEventID === '0') {
            setPackageList([]);
            setProductList([]);
            return;
        }
        if (_ItemMode === 1 && _ItemRefID > 0) _GetPackageList(_ItemRefID);
        if (_ItemMode === 2 && _ItemRefID > 0) _GetProductList(_ItemRefID);
    }
    const _NewItemPackage = (Package) => {
        const _Event = _EventList?.find(e => e.CustomerEventId === _CustomerEventID);

        const _Item = {
            LineNumber: _ItemSaveLength + 1,
            CustomerEventId:_CustomerEventID,
            CustomerEvent:_Event,
            RefType:1,
            RefID:Package.PackageId,
            Name : Package.PackageName,
            Description : Package.Description,
            GroupName : Package.PackageGroupName,
            GroupId:Package.PackageGroupId,
            UnitPrice : Package.Price,
            PackagePriceId : 0,
            TotalAmount:0,
            DiscountAmount:0,
            FOC:false,
            Promotion:null,
            Remark:Package.Remark
        }

        if (props.callback != undefined) {
            try { props.callback(_Item); } catch (e) { }
        }
        _CloseModel();
    }

    const _NewItemProduct = (Product) => {
        const _Event = _EventList?.find(e => e.CustomerEventId === _CustomerEventID);

        const _Item = {
            LineNumber:_ItemSaveLength + 1,
            CustomerEventId:_CustomerEventID,
            CustomerEvent:_Event,
            RefType:2,
            RefID:Product.ProductId,
            Name : Product.ProductName,
            Description : Product.Description,
            GroupName : Product.ProductTypeName,
            GroupId:Product.ProductTypeId,
            UnitPrice : Product.Price,
            PackagePriceId : 0,
            TotalAmount:0,
            DiscountAmount:0,
            FOC:false,
            Promotion:null,
            Remark:null
        }

        if (props.callback != undefined) {
            try { props.callback(_Item); } catch (e) { }
        }
        _CloseModel();
    }

    return (
        <>
            <Modal isOpen={ModalState} className={'modal-xl'} centered={true} unmountOnClose={true}>
                <div className="modal-header">
                    <h5 className="modal-title">เลือกรายการแพ็คเกจ / สินค้า</h5>
                    <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={() => { _CloseModel() }}></button>
                </div>
                <div className='modal-body' style={{ 'minHeight': '500px' }}>
                    <div className='row justify-content-between'>
                        <div className='col-lg-3'>
                            <div className="btn-group">
                                <button className={(_ItemMode === 1 ? "btn btn-primary active" : "btn btn-secondary")} onClick={() => { setItemMode(1); }}>แพ็คแก็จ</button>
                                <button className={(_ItemMode === 2 ? "btn btn-primary active" : "btn btn-secondary")} onClick={() => { setItemMode(2); }}>สินค้า</button>
                            </div>
                        </div>
                        <div className='col-lg-6 align-self-end align-self-lg-end text-end'>
                            <div className='d-flex'>
                                <div className='form-group'>
                                    <select className='form-control' style={{ 'width': '200px', 'marginRight': '20px' }} onChange={(e) => { _ItemChangeEvent(e.currentTarget?.value); }}>
                                        <option value={0} className='text-center'>เวลาจัดงาน</option>
                                        {_EventList?.map((ev, i) => {
                                            return <option key={i} value={ev.CustomerEventId}>{DateFormat(ev.EventStart, true)}</option>;
                                        })}
                                    </select>
                                </div>
                                <div className='form-group'>
                                    {(_ItemMode === 1 ?
                                        <select className='form-control' disabled={(_CustomerEventID === null ? true : false)} style={{ 'width': '200px' }} onChange={(e) => { _GetPackageList(e.currentTarget?.value); }}>
                                            <option value={0} selected={true} className='text-center'>เลือกกลุ่ม</option>
                                            {PackageGroupList.map((v, i) => (
                                                <option key={i} value={(v.packageGroupId)}>{v.packageGroupName}</option>
                                            ))}
                                        </select>
                                        : "")}
                                    {(_ItemMode === 2 ?
                                        <select className='form-control' disabled={(_CustomerEventID === null ? true : false)} style={{ 'width': '200px' }} onChange={(e) => { _GetProductList(e.currentTarget?.value); }}>
                                            <option value={0} selected={true} className='text-center'>เลือกประเภท</option>
                                            {_ProductTypeList.map((v, i) => (
                                                <option key={i} value={(v.productTypeId)}>{v.productTypeName}</option>
                                            ))}
                                        </select>
                                        : "")}
                                </div>
                            </div>
                        </div>
                    </div>
                    {(_ItemMode === 1 ?
                        <div className='row mt-3'>
                            <div className='col-lg-12'>
                                <table className='table'>
                                    <thead>
                                        <tr>
                                            <th className='text-center'>รหัส</th>
                                            <th className='text-center'>แพ็คแก็จ</th>
                                            <th className='text-center'>รายละเอียด</th>
                                            <th className='text-center'>ราคาต่อหน่วย</th>
                                            <th className='text-center'>จำนวนงาน</th>
                                            <th className='text-center'></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {_PackageList.map((v, i) => (
                                            <tr key={i}>
                                                <td className='text-center'>{v.PackageCode}</td>
                                                <td className='text-left'>{v.PackageName}</td>
                                                <td className='text-left'>{v.Description}</td>
                                                <td className='text-end'>{NumberFormat(v.Price)}</td>
                                                <td className='text-center'>{NumberFormat(v.QuoteQuantity)} / {NumberFormat(v.DepositQuantity)} / {NumberFormat(v.QuantityLimit)}</td>
                                                <td className='text-center'>
                                                    <button className='btn btn-success btn-sm' onClick={() => { _NewItemPackage(v); }}>เลือก</button>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        : "")}
                    {(_ItemMode === 2 ?
                        <div className='row mt-3'>
                            <div className='col-lg-12'>
                                <table className='table'>
                                    <thead>
                                        <tr>
                                            <th className='text-center'>สินค้า</th>
                                            <th className='text-center'>รายละเอียด</th>
                                            <th className='text-center'>ราคาต่อหน่วย</th>
                                            <th className='text-center'>จำนวนงาน</th>
                                            <th className='text-center'></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {_ProductList.map((v, i) => (
                                            <tr key={i}>
                                                <td className='text-left'>{v.ProductName}</td>
                                                <td className='text-left'>{v.Description}</td>
                                                <td className='text-end'>{NumberFormat(v.Price)}</td>
                                                <td className='text-center'>{NumberFormat(v.QuoteQuantity)} / {NumberFormat(v.DepositQuantity)} / {NumberFormat(v.QuantityLimit)}</td>
                                                <td className='text-center'>
                                                    <button className='btn btn-success btn-sm' onClick={() => { _NewItemProduct(v); }}>เลือก</button>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        : "")}
                </div>
            </Modal>
        </>
    );
});

export default React.memo(QuotationItem)
